import { OSS_MEDIA_BASE_URL } from "@gunziai/constants/shared/storage-config.constant";

export function invalidateStorageAssetConfigCache() {}

function joinUrl(base: string, path: string): string {
    return `${base.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
}

function isStorageAssetPath(path: string): boolean {
    const normalizedPath = path.replace(/^\/+/, "");
    return /(^|\/)(uploads|static)\//i.test(normalizedPath);
}

function getStorageAssetPath(path: string): string | null {
    const normalizedPath = path.trim();
    if (!normalizedPath) return null;

    if (/^https?:\/\//i.test(normalizedPath)) {
        try {
            const url = new URL(normalizedPath);
            const assetPath = `${url.pathname.replace(/^\/+/, "")}${url.search}${url.hash}`;
            return isStorageAssetPath(assetPath) ? assetPath : null;
        } catch {
            return null;
        }
    }

    const assetPath = normalizedPath.replace(/^\/+/, "");
    return isStorageAssetPath(assetPath) ? assetPath : null;
}

export async function resolveStorageAssetUrl(path: string): Promise<string> {
    if (!path) return "";
    const assetPath = getStorageAssetPath(path);
    if (!assetPath) {
        return path;
    }

    return joinUrl(OSS_MEDIA_BASE_URL, assetPath);
}
